/**
 * @name CollectionGroupItemGroup
 * @property {*} group
 * @property {number} index
 * @property {[]} items
 */
export class CollectionGroup {
  groupExtractor;
  /** @type CollectionGroupItemGroup[] */
  itemGroups = [];
  itemCount = 0;

  constructor(groupExtractor = null) {
    this.setGroupExtractor(groupExtractor);
  }

  setGroupExtractor(groupExtractor) {
    this.groupExtractor = groupExtractor;
  }

  /**
   * Group given item and return group
   * @param {*} item
   * @return {CollectionGroupItemGroup}
   */
  group(item) {
    const { itemGroups, itemCount, groupExtractor } = this;
    const group = groupExtractor?.(item, this);
    let itemGroup;
    for (let g = itemGroups.length - 1; g >= 0; --g) {
      if (itemGroups[g].group === group) {
        itemGroup = itemGroups[g];
        break;
      }
    }
    if (!itemGroup) {
      const index = itemGroups.length;
      itemGroup = { group, index, items: [] };
      itemGroups[index] = itemGroup;
    }
    itemGroup.items[itemGroup.items.length] = item;
    return itemGroup;
  }

  forEach(fn) {
    const { itemGroups } = this;
    for (let i = 0; i < itemGroups.length; ++i) {
      fn(itemGroups[i], i, this);
    }
  }
}

export class CollectionTransformer {
  sourceItems;
  items = [];
  transformer;

  constructor(sourceItems, transformer) {
    this.setSourceItems(sourceItems);
    this.setTransformer(transformer);
  }

  setSourceItems(sourceItems) {
    this.sourceItems = sourceItems;
  }

  setTransformer(transformer) {
    this.transformer = transformer;
  }

  processNewItems() {
    const { sourceItems } = this;
    const newCount = sourceItems?.length;
    let processed = 0;
    if (!newCount) {
      return processed;
    }
    const { items, transformer } = this;
    const itemCount = items.length;
    for (let i = itemCount; i < newCount; ++i) {
      items[i] = !transformer ? sourceItems[i]
        : transformer(sourceItems[i], i, processed, this);
      ++processed;
    }
    return processed;
  }
}

export class CollectionWindow {
  items;
  start;
  end;
  startItem;
  endItem;

  constructor(items, start = 0, end = items.length) {
    this.setItems(items);
    this.setBounds(start, end);
  }

  setItems(items) {
    this.items = items;
  }

  setBounds(start, end) {
    const { items } = this;
    this.start = start;
    this.end = end;
    this.startItem = start <= 0 ? this.defaultStartItem : items[start - 1];
    this.endItem = end >= items.length ? this.defaultEndItem : items[end];
  }

  setDefaultBoundItems(defaultStartItem, defaultEndItem) {
    this.defaultStartItem = defaultStartItem;
    this.defaultEndItem = defaultEndItem;
  }
}
